import script from "./CodeEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeEditor.vue?vue&type=script&setup=true&lang=js"

import "./CodeEditor.vue?vue&type=style&index=0&id=6db0b494&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6db0b494"]])

export default __exports__